//----------  On Product Listing pages, show company and product values, if applicable ----------
  //TODO: Update sources every time image for icon is replaced
  function replaceCompanyValueImages() {
    //Made in USA
    var made_in_usa_elts = document.getElementsByClassName("made_in_usa");
    if(made_in_usa_elts != null) {
      var made_in_usa_size = made_in_usa_elts.length;
      for(var i = 0; i < made_in_usa_size; i++) {
        var made_in_usa = made_in_usa_elts[i];
        made_in_usa.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/MadeInTheUSA_White.png?v=1636059426";
      }
    }

    //Made in CA
    var made_in_ca_elts = document.getElementsByClassName("made_in_ca");
    if(made_in_ca_elts != null) {
      var made_in_ca_size = made_in_ca_elts.length;
      for(var i = 0; i < made_in_ca_size; i++) {
        var made_in_ca = made_in_ca_elts[i];
        made_in_ca.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/MadeInCalifornia_White.png?v=1636059426";
      }
    }

    //1% For the Planet
    var one_percent_for_planet_elts = document.getElementsByClassName("one_percent_for_planet");
    if(one_percent_for_planet_elts != null) {
      var one_percent_for_planet_size = one_percent_for_planet_elts.length;
      for(var i = 0; i < one_percent_for_planet_size; i++) {
        var one_percent_for_planet = one_percent_for_planet_elts[i];
        one_percent_for_planet.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/1PercentForThePlanetMember_White.png?v=1636059426";
      }
    }

    //Certified B-Corporation
    var b_corporation_elts = document.getElementsByClassName("b_corporation");
    if(b_corporation_elts != null) {
      var b_corporation_size = b_corporation_elts.length;
      for(var i = 0; i < b_corporation_size; i++) {
        var b_corporation = b_corporation_elts[i];
        b_corporation.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/CertifiedBCorporation_White.png?v=1636059426";
      }
    }

    //Small Business
    var small_business_elts = document.getElementsByClassName("small_business");
    if(small_business_elts != null) {
      var small_business_size = small_business_elts.length;
      for(var i = 0; i < small_business_size; i++) {
        var small_business = small_business_elts[i];
        small_business.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/SmallBusiness_White.png?v=1636059426";
      }
    }

    //Family Owned
    var family_owned_elts = document.getElementsByClassName("family_owned");
    if(family_owned_elts != null) {
      var family_owned_size = family_owned_elts.length;
      for(var i = 0; i < family_owned_size; i++) {
        var family_owned = family_owned_elts[i];
        family_owned.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/FamilyOwned_White.png?v=1636059426";
      }
    }

    //Woman Owned
    var woman_owned_elts = document.getElementsByClassName("woman_owned");
    if(woman_owned_elts != null) {
      var woman_owned_size = woman_owned_elts.length;
      for(var i = 0; i < woman_owned_size; i++) {
        var woman_owned = woman_owned_elts[i];
        woman_owned.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/WomanOwned_White.png?v=1636059426";
      }
    }

    //Minority Owned
    var minority_owned_elts = document.getElementsByClassName("minority_owned");
    if(minority_owned_elts != null) {
      var minority_owned_size = minority_owned_elts.length;
      for(var i = 0; i < minority_owned_size; i++) {
        var minority_owned = minority_owned_elts[i];
        minority_owned.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/MinorityOwned_White.png?v=1636060206";
      }
    }
  }

  //TODO: Update sources every time image for icon is replaced
  function replaceProductValueImages() {
    //Vegan
    var vegan_elts = document.getElementsByClassName("vegan");
    if(vegan_elts != null) {
      var vegan_size = vegan_elts.length;
      for(var i = 0; i < vegan_size; i++) {
        var vegan = vegan_elts[i];
        vegan.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/Vegan.png?v=1632894877";
      }
    }

    //Cruelty Free
    var cruelty_free_elts = document.getElementsByClassName("cruelty_free");
    if(cruelty_free_elts != null) {
      var cruelty_free_size = cruelty_free_elts.length;
      for(var i = 0; i < cruelty_free_size; i++) {
        var cruelty_free = cruelty_free_elts[i];
        cruelty_free.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/CrueltyFree.png?v=1632890749";
      }
    }

    //Leaping Bunny Certified
    var leaping_bunny_certified_elts = document.getElementsByClassName("leaping_bunny_certified");
    if(leaping_bunny_certified_elts != null) {
      var leaping_bunny_certified_size = leaping_bunny_certified_elts.length;
      for(var i = 0; i < leaping_bunny_certified_size; i++) {
        var leaping_bunny_certified = leaping_bunny_certified_elts[i];
        leaping_bunny_certified.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/LeapingBunnyCertified.png?v=1632890749";
      }
    }

    //Biodegradable
    var biodegradable_elts = document.getElementsByClassName("biodegradable");
    if(biodegradable_elts != null) {
      var biodegradable_size = biodegradable_elts.length;
      for(var i = 0; i < biodegradable_size; i++) {
        var biodegradable = biodegradable_elts[i];
        biodegradable.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/Biodegradable.png?v=1632890749";
      }
    }

    //Plant Based
    var plant_based_elts = document.getElementsByClassName("plant_based");
    if(plant_based_elts != null) {
      var plant_based_size = plant_based_elts.length;
      for(var i = 0; i < plant_based_size; i++) {
        var plant_based = plant_based_elts[i];
        plant_based.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/PlantBased.png?v=1632890749";
      }
    }

    //Organic Ingredients
    var organic_ingredients_elts = document.getElementsByClassName("organic_ingredients");
    if(organic_ingredients_elts != null) {
      var organic_ingredients_size = organic_ingredients_elts.length;
      for(var i = 0; i < organic_ingredients_size; i++) {
        var organic_ingredients = organic_ingredients_elts[i];
        organic_ingredients.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/OrganicIngredients.png?v=1632890749";
      }
    }

    //Locally Sourced
    var locally_sourced_elts = document.getElementsByClassName("locally_sourced");
    if(locally_sourced_elts != null) {
      var locally_sourced_size = locally_sourced_elts.length;
      for(var i = 0; i < locally_sourced_size; i++) {
        var locally_sourced = locally_sourced_elts[i];
        locally_sourced.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/LocallySourced.png?v=1632890749";
      }
    }

    //Septic Safe
    var septic_safe_elts = document.getElementsByClassName("septic_safe");
    if(septic_safe_elts != null) {
      var septic_safe_size = septic_safe_elts.length;
      for(var i = 0; i < septic_safe_size; i++) {
        var septic_safe = septic_safe_elts[i];
        septic_safe.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/SepticSafe.png?v=1632890749";
      }
    }

    //Handmade
    var handmade_elts = document.getElementsByClassName("handmade");
    if(handmade_elts != null) {
      var handmade_size = handmade_elts.length;
      for(var i = 0; i < handmade_size; i++) {
        var handmade = handmade_elts[i];
        handmade.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/Handmade.png?v=1632890749";
      }
    }

    //Small Batches
    var small_batches_elts = document.getElementsByClassName("small_batches");
    if(small_batches_elts != null) {
      var small_batches_size = small_batches_elts.length;
      for(var i = 0; i < small_batches_size; i++) {
        var small_batches = small_batches_elts[i];
        small_batches.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/SmallBatches.png?v=1632890749";
      }
    }

    //Synthetic Fragrance Free
    var synthetic_fragrance_free_elts = document.getElementsByClassName("synthetic_fragrance_free");
    if(synthetic_fragrance_free_elts != null) {
      var synthetic_fragrance_free_size = synthetic_fragrance_free_elts.length;
      for(var i = 0; i < synthetic_fragrance_free_size; i++) {
        var synthetic_fragrance_free = synthetic_fragrance_free_elts[i];
        synthetic_fragrance_free.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/SynthethicFragranceFree.png?v=1632890749";
      }
    }

    //Dye Free
    var dye_free_elts = document.getElementsByClassName("dye_free");
    if(dye_free_elts != null) {
      var dye_free_size = dye_free_elts.length;
      for(var i = 0; i < dye_free_size; i++) {
        var dye_free = dye_free_elts[i];
        dye_free.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/DyeFree.png?v=1632890749";
      }
    }

    //Paraben Free
    var paraben_free_elts = document.getElementsByClassName("paraben_free");
    if(paraben_free_elts != null) {
      var paraben_free_size = paraben_free_elts.length;
      for(var i = 0; i < paraben_free_size; i++) {
        var paraben_free = paraben_free_elts[i];
        paraben_free.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/ParabenFree.png?v=1632890749";
      }
    }

    //Sulfate Free
    var sulfate_free_elts = document.getElementsByClassName("sulfate_free");
    if(sulfate_free_elts != null) {
      var sulfate_free_size = sulfate_free_elts.length;
      for(var i = 0; i < sulfate_free_size; i++) {
        var sulfate_free = sulfate_free_elts[i];
        sulfate_free.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/SulfateFree.png?v=1632890749";
      }
    }

    //Gluten Free
    var gluten_free_elts = document.getElementsByClassName("gluten_free");
    if(gluten_free_elts != null) {
      var gluten_free_size = gluten_free_elts.length;
      for(var i = 0; i < gluten_free_size; i++) {
        var gluten_free = gluten_free_elts[i];
        gluten_free.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/GlutenFree.png?v=1632890749";
      }
    }

    //Artificial Colors Free
    var artificial_colors_free_elts = document.getElementsByClassName("artificial_colors_free");
    if(artificial_colors_free_elts != null) {
      var artificial_colors_free_size = artificial_colors_free_elts.length;
      for(var i = 0; i < artificial_colors_free_size; i++) {
        var artificial_colors_free = artificial_colors_free_elts[i];
        artificial_colors_free.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/ArtificialColorsFree.png?v=1632890749";
      }
    }

    //Fluoride Free
    var fluoride_free_elts = document.getElementsByClassName("fluoride_free");
    if(fluoride_free_elts != null) {
      var fluoride_free_size = fluoride_free_elts.length;
      for(var i = 0; i < fluoride_free_size; i++) {
        var fluoride_free = fluoride_free_elts[i];
        fluoride_free.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/FluorideFree.png?v=1632890749";
      }
    }

    //Aluminum Free
    var aluminum_free_elts = document.getElementsByClassName("aluminum_free");
    if(aluminum_free_elts != null) {
      var aluminum_free_size = aluminum_free_elts.length;
      for(var i = 0; i < aluminum_free_size; i++) {
        var aluminum_free = aluminum_free_elts[i];
        aluminum_free.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/AluminumFree.png?v=1632890749";
      }
    }

    //Preservative Free
    var preservative_free_elts = document.getElementsByClassName("preservative_free");
    if(preservative_free_elts != null) {
      var preservative_free_size = preservative_free_elts.length;
      for(var i = 0; i < preservative_free_size; i++) {
        var preservative_free = preservative_free_elts[i];
        preservative_free.src = "https://cdn.shopify.com/s/files/1/0513/4316/3545/files/PreservativeFree.png?v=1632890749";
      }
    }
  }

  window.addEventListener("load", function(){
    replaceCompanyValueImages();
    replaceProductValueImages();
  });